import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { EstimationAmountState } from "../estimationAmount/estimationAmountSlice";
import { createSelector } from "reselect";
import { startOfDay } from "date-fns";

// 初期状態の定義
const initialState: EstimationAmountState[] = [];
export interface payloadUpdateDeliveryPlan {
  index: number;
  deliveryDate: string;
  flexSettingId?: number | null;
  [key: string]: any;
}

export const estimationAmountListSlice = createSlice({
  name: "estimationAmountList",
  initialState,
  reducers: {
    addEstimationToList: (
      state,
      action: PayloadAction<EstimationAmountState>
    ) => {
      // 新しい値を取得
      const newValue: EstimationAmountState = {
        ...action.payload,
        status: "uploaded", // statusを成功として設定
      };
      // 新しい配列を作成して追加
      // state = [...state, newValue];
      // 新しい状態を返す（Redux Toolkitのimmerによって、直接状態を変更できないため）
      return [...state, newValue];
    },
    //Update amount accroding checkbox
    updateEstimationFromList: (
      state,
      action: PayloadAction<payloadUpdateDeliveryPlan>
    ) => {
      if (
        state[action.payload.index].estimationAmount ===
          action.payload.estimationAmount &&
        state[action.payload.index].checkBox &&
        startOfDay(new Date(action.payload.deliveryDate)).getTime() ===
          startOfDay(
            new Date(state[action.payload.index].estimationDateTime)
          ).getTime()
      ) {
        state[action.payload.index].checkBox = false;
        state[action.payload.index].estimationAmount = null;
        state[action.payload.index].estimationDateTime = "";
        state[action.payload.index].flexSettingId = null;
      } else {
        state[action.payload.index].estimationAmount =
          action.payload.estimationAmount;
        state[action.payload.index].estimationDateTime =
          action.payload.deliveryDate;
        state[action.payload.index].checkBox = true;
        state[action.payload.index].flexSettingId =
          action.payload.flexSettingId ?? null;
      }
    },
    // BE が保存した納期を、選択中の明細（checkBox）に先頭から順に反映する。null はそのまま
    setCheckedDeliveryDates: (
      state,
      action: PayloadAction<(string | null)[]>
    ) => {
      state
        .filter((item) => item.checkBox)
        .forEach((item, index) => {
          const deliveryDate = action.payload[index];
          if (deliveryDate) item.estimationDateTime = deliveryDate;
        });
    },
    removeEstimationFromList: (state, action: PayloadAction<number>) => {
      // 受け取ったインデックスを使って、そのインデックスの要素を除外した新しい配列を作成
      return state.filter((_, index) => index !== action.payload);
    },
    removeEstimation: () => {
      return [];
    },
    toggleCheckBox: (state, action: PayloadAction<number>) => {
      const index = action.payload;
      state[index] = {
        ...state[index],
        checkBox: !state[index].checkBox,
      };
    },
    toggleCheckBoxAll: (state, action: PayloadAction<boolean>) => {
      const checkStatus = action.payload;
      return state.map((item) => ({
        ...item,
        checkBox: checkStatus,
      }));
    },
  },
});
// 読み出し用
export const selectEstimationAmountList = (state: RootState) =>
  state.estimationAmountList;
export const selectCheckedEstimationAmountList = createSelector(
  [selectEstimationAmountList],
  (estimationAmountList) => {
    return estimationAmountList.filter((item) => item.checkBox);
  }
);
// action用
export const {
  addEstimationToList,
  updateEstimationFromList,
  setCheckedDeliveryDates,
  removeEstimation,
  removeEstimationFromList,
  toggleCheckBox,
  toggleCheckBoxAll,
} = estimationAmountListSlice.actions;
export default estimationAmountListSlice.reducer;
